/**
 * API Client Configuration
 * Centralized axios instance with interceptors for requests/responses
 */

import axios from "axios";
import config from "../../config/env";

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: config.apiUrl,
  timeout: 10000, // 10 seconds
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - runs before every request
apiClient.interceptors.request.use(
  requestConfig => {
    // Add auth token if available
    const token = localStorage.getItem("token");
    if (token) {
      requestConfig.headers.Authorization = `Bearer ${token}`;
    }

    // Log requests in development
    if (config.isDevelopment) {
      console.log(`API Request: ${requestConfig.method?.toUpperCase()} ${requestConfig.url}`);
    }

    return requestConfig;
  },
  error => {
    // Handle request error
    console.error("Request error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor - runs after every response
apiClient.interceptors.response.use(
  response => {
    // Return only the data part of the response
    return response.data;
  },
  error => {
    // Handle common errors
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;

      switch (status) {
        case 401:
          // Unauthorized - clear token and redirect to login
          localStorage.removeItem("token");
          // Only redirect if not already on login page
          if (!window.location.pathname.includes("login")) {
            // window.location.href = "/login";
            console.warn("Unauthorized - token cleared");
          }
          break;
        case 403:
          console.error("Forbidden - insufficient permissions");
          break;
        case 404:
          console.error("Resource not found");
          break;
        case 500:
          console.error("Server error - please try again later");
          break;
        default:
          console.error(`API Error: ${status}`, data);
      }
    } else if (error.request) {
      // Request made but no response received
      console.error("Network error - please check your connection");
    } else {
      // Something else happened
      console.error("Error:", error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
